module.exports = __webpack_public_path__ + "static/media/corrente_fechada.ba9ce288.svg";